export default __webpack_public_path__ + "static/media/411.7ec6262b.gif";